import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { NumberValue } from 'elements/minute/sidebar/sidebarComponents/atomic/NumberValue';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSection } from 'elements/minute/sidebar/sidebarSection/SidebarSection';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { rotateAndScalePolygon } from 'hooks/coordinates/useCoordinatesComputations';
import { round } from 'lodash';
import { useContext } from 'react';
import { IWallV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';
interface Props {
    className?: string;
    marker: IWallV2WorldMarker;
}

export const WallMarkerTransform = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const { marker } = props;

    function rotate(rotation: number) {
        const coordinates = rotateAndScalePolygon(
            marker.elementData.nonTransformedCoordinates,
            rotation,
            marker.elementData.scale
        );

        ctxEdit.updateWorldMarkerData(marker.id, {
            coordinates,
            rotation
        });
    }

    function scale(_scale: number) {
        const scale = round(_scale, 2);
        const coordinates = rotateAndScalePolygon(
            marker.elementData.nonTransformedCoordinates,
            marker.elementData.rotation,
            scale
        );

        ctxEdit.updateWorldMarkerData(marker.id, {
            coordinates,
            scale
        });
    }

    return (
        <S_WallMarkerTransform className={props.className}>
            <SidebarSection title={Localization.TRANSFORM} icon={{ iconName: 'rotate' }}>
                <SidebarSubsection title={Localization.ROTATE} icon={{ iconName: 'rotate' }}>
                    <SidebarContent>
                        <S_Row>
                            <ActionButton
                                text="- -"
                                onClick={() => rotate(marker.elementData.rotation - 10)}
                            />
                            <ActionButton
                                text="-"
                                onClick={() => rotate(marker.elementData.rotation - 5)}
                            />
                            <NumberValue
                                value={marker.elementData.rotation ?? 0}
                                onChange={rotate}
                            />
                            <ActionButton
                                text="+"
                                onClick={() => rotate(marker.elementData.rotation + 5)}
                            />
                            <ActionButton
                                text="+ +"
                                onClick={() => rotate(marker.elementData.rotation + 10)}
                            />
                        </S_Row>
                    </SidebarContent>
                </SidebarSubsection>
                <SidebarSubsection
                    title={Localization.SCALE}
                    icon={{ iconName: 'arrow-up-right-and-arrow-down-left-from-center' }}
                >
                    <SidebarContent>
                        <S_Row>
                            <ActionButton
                                text="- -"
                                onClick={() => scale(marker.elementData.scale - 1)}
                            />
                            <ActionButton
                                text="-"
                                onClick={() => scale(marker.elementData.scale - 0.05)}
                            />
                            <NumberValue
                                value={marker.elementData.scale ?? 1}
                                placeholder={Localization.SCALE}
                                onChange={scale}
                            />
                            <ActionButton
                                text="+"
                                onClick={() => scale(marker.elementData.scale + 0.05)}
                            />
                            <ActionButton
                                text="+ +"
                                onClick={() => scale(marker.elementData.scale + 1)}
                            />
                        </S_Row>
                    </SidebarContent>
                </SidebarSubsection>
            </SidebarSection>
        </S_WallMarkerTransform>
    );
};

const S_WallMarkerTransform = styled.div``;

const S_Row = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`;
